<p-toast position="top-right"></p-toast>

<p-dialog *ngIf="displayAlreadyExistDialog"
          [(visible)]="displayAlreadyExistDialog"
          header="This email already has a designated role."
          [modal]="true"
          [style]="{ width: '700px', height: '200px' }"
          [draggable]="false"
          [resizable]="false"
          [closable]="true">
    <p-header [ngStyle] = "{'font-family': 'Poppins, sans-serif', 'font-size': '19px'}">
        This email already has a designated role.
    </p-header>
    <ng-template pTemplate="item">
        <div class="modal-content-center">
            <div class="oops">Oops! This email has already been assigned a role. 
                Please ensure you are using the correct email or contact support for assistance.</div>
        </div>
        <button pButton
                [ngStyle]="{ width: '70px', height: '36px', float: 'right', padding: '0' }"
                class="p-element btn-darkblue p-button p-component mr-1"
                label="Got it"
                (click)="confirmAlreadyExistDialog()"></button>
    </ng-template>
    <ng-template pTemplate="footer"></ng-template>
</p-dialog>

<p-dialog *ngIf="displayConfirmDialog"
          [(visible)]="displayConfirmDialog"
          [modal]="true"
          [style]="{ width: '40vw' }"
          [draggable]="false"
          [resizable]="false"
          [closable]="true">
    <ng-template pTemplate="item">
        <div class="modal-content-center">
            <h1>{{ isUserExist ? "Update User Details?" : "Create New User?" }}</h1>
        </div>
        <div class="modal-content-center">
            <p>
                {{ isUserExist ? "Are you sure you want to update user?" : "Are you sure you want to create new user?" }}
            </p>
            <br/>
        </div>
        <div class="modal-buttons-container">
            <button pButton
                    icon="pi pi-check"
                    class="p-element btn-darkblue p-button p-component mr-1"
                    label="Confirm"
                    (click)="confirmAction()"></button>
            <button pButton
                    icon="pi pi-times"
                    label="Cancel"
                    class="p-element btn-cancel p-button p-component"
                    (click)="changeConfirmDialogVisibility()"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="footer"></ng-template>
</p-dialog>

<p-sidebar [(visible)]="showSidebar"
           [position]="'right'"
           (onHide)="cancel()"
           [style]="{width:'750px'}">
    <ng-template pTemplate="header">{{ isUserExist ? "Update User" : "Add User" }}</ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">

        <div class="user-details">{{ isUserExist ? 'Update' : 'Add' }} details for this user</div>

        <p-scrollPanel [style]="{width:'100%', height: 'calc(71vh)', marginTop: '1%'}"
                       [styleClass]="'app-scrollpanel'">

            <form #roleForm="ngForm">
                <div class="flex flex-row">
                    <div class="col-4 p-2">
                        <div class="new-diciplinary-label">{{firstLabel}} Name</div>
                        <input type="text" [(ngModel)]="selectedUser.FirstName" name="FirstName" required placeholder="Enter {{firstLabel}} Name" pInputText />
                    </div>
                    <div class="col-4 p-2">
                        <div class="new-diciplinary-label">{{lastLabel}} Name</div>
                        <input type="text" [(ngModel)]="selectedUser.LastName" name="LastName" required placeholder="Enter {{lastLabel}} Name" pInputText />
                    </div>
                    <div class="col-4 p-2">
                        <div class="new-diciplinary-label">Email</div>
                        <input type="text" [(ngModel)]="selectedUser.Email" name="Email" required placeholder="Enter Email" pInputText />
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="col-6 p-2">
                        <div class="new-diciplinary-label">Role</div>
                        <p-dropdown placeholder="Select Role"
                                    [(ngModel)]="selectedUser.RoleId"
                                    [options]="roles"
                                    name="Role"
                                    optionLabel="Name"
                                    optionValue="Id"
                                    (onChange)="onSelectedRoleChange()"
                                    [showClear]="true"></p-dropdown>
                    </div>

                    <div class="col-6 p-2">
                        <div class="new-diciplinary-label">Password</div>
                        <div style="display: flex">
                            <input type="text" [(ngModel)]="selectedUser.Password" name="Password" [ngModelOptions]="{ standalone: isUserExist }"
                                   style="width: 90%" required placeholder="Enter Password" pInputText />
                            <button type="button" class="btn-generate" (click)="generatePassword()">
                                <img class="driver-stats-img-award" src="/XpressApp/assets/images/generate_password.svg" />
                            </button>
                            <button type="button" class="btn-copy" (click)="copyPassword()">
                                <img class="driver-stats-img-award" src="/XpressApp/assets/images/copy_password.svg" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="col-6 p-2">
                        <div class="new-diciplinary-label">Xpress Zones</div>
                        <p-multiSelect [options]="xpressZones" placeholder="Select Zones" name="Zones" filterPlaceHolder="Search here"
                                       optionLabel="Name" optionValue="Id" [(ngModel)]="selectedUser.AdminLocations" />
                    </div>
                    <div class="col-6 p-2">
                        <div class="new-diciplinary-label">Phone</div>
                        <input type="text" [(ngModel)]="selectedUser.Phone" name="Phone" required placeholder="Enter Phone Number (e.g., +639123456789)" pInputText />
                    </div>
                </div>

                <div class="flex flex-row" *ngIf="showMerchants">
                    <div class="col-6 p-2">
                        <div class="new-diciplinary-label">Merchants</div>
                        <p-multiSelect [options]="merchants" placeholder="Select Merchants" name="Merchants" filterPlaceHolder="Search here"
                                       optionLabel="Name" optionValue="Id" [(ngModel)]="selectedUser.MerchantId" />
                    </div>
                </div>

                <div class="flex flex-row" *ngIf="showTourOperators">
                    <div class="col-6 p-2">
                        <div class="new-diciplinary-label">Tour Operators</div>
                        <p-multiSelect [options]="tourOperators" placeholder="Select TourOperators" name="TourOperators" filterPlaceHolder="Search here"
                                       optionLabel="Name" optionValue="Id" [(ngModel)]="selectedUser.TourOperatorIds" />
                    </div>
                </div>
            </form>
        </p-scrollPanel>

        <div style="position: sticky; bottom: 20px;">
            <hr />
            <div class="flex justify-content-end">
                <button pButton
                        class="p-element btn-darkblue p-button p-component mr-1" [ngClass]="{ 'btn-disabled': !roleForm.valid || !selectedUser.RoleId || !selectedUser.AdminLocations || selectedUser.AdminLocations.length === 0 }"
                        [label]=" isUserExist ? 'Update' : 'Create'"
                        (click)="showConfirmDialog()"
                        [disabled]="!roleForm.valid || !selectedUser.RoleId || !selectedUser.AdminLocations || selectedUser.AdminLocations.length === 0"></button>
            </div>
        </div>
    </div>
</p-sidebar>
